export const AiBadge = ({ label = "AI-Estimated", className = "" }) => (
  <span
    data-testid="ai-estimated-badge"
    className={`inline-flex items-center gap-1 bg-amber-500/10 text-amber-400 border border-amber-500/30 text-[10px] font-mono-sw px-2 py-0.5 rounded-full shadow-[0_0_10px_rgba(245,158,11,0.2)] ${className}`}
  >
    {label}
  </span>
);

export const DemoBadge = ({ label = "DEMO", className = "" }) => (
  <span
    data-testid="demo-badge"
    className={`inline-flex items-center gap-1 bg-cyan-500/10 text-cyan-400 border border-cyan-500/30 text-[10px] font-mono-sw px-2 py-0.5 rounded-full shadow-[0_0_10px_rgba(6,182,212,0.2)] ${className}`}
  >
    {label}
  </span>
);

export const ConfidenceBadge = ({ value, className = "" }) => {
  if (value == null) return null;
  const pct = Math.round(value * 100);
  const color =
    pct >= 85 ? "text-emerald-400 border-emerald-500/30 bg-emerald-500/10" :
    pct >= 70 ? "text-cyan-400 border-cyan-500/30 bg-cyan-500/10" :
    "text-amber-400 border-amber-500/30 bg-amber-500/10";
  return (
    <span className={`inline-flex items-center text-[10px] font-mono-sw px-1.5 py-0.5 rounded-full border ${color} ${className}`}>
      {pct}%
    </span>
  );
};
